import { Component, HostListener, ViewEncapsulation } from '@angular/core';

const BUTTON_HOST_ATTRIBUTES = ['button', 'ca-button', 'ca-button-action', 'cta', 'large'];

@Component({
  selector: `button[ca-button], button[caButton]`,
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./button.scss'],
})
export class CaButtonComponent {
  @HostListener('disabled') disabled;
}
